import { useState, useEffect } from "react";
import { SheetDataPoint, Winner } from "../../types";
import useElectionsData from "../../hooks/useElectionsData";
import GraphOptions from "./GraphOptions";
import Graph from "./Graph";
import { findLastIndex, getRandomColor, WINNER_COLORS } from "../../util";

function GraphSection() {
  const electionsData = useElectionsData();
  const [scopedElectionsData, setScopedElectionsData] = useState<
    SheetDataPoint[]
  >(electionsData.sheetData);

  const [scopedDistinctWinners, setScopedDistinctWinners] = useState<Winner[]>(
    [],
  );
  const [selectedWinners, setSelectedWinners] = useState<Winner[]>([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    if (!startDate || !endDate) return;
    setScopedElectionsData(scopeElectionsDataByDate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [electionsData.sheetData, startDate, endDate]);

  useEffect(() => {
    setScopedDistinctWinners(getDistinctWinners(scopedElectionsData));
  }, [scopedElectionsData]);

  function scopeElectionsDataByDate() {
    setSelectedWinners([]);
    return electionsData.sheetData.slice(
      electionsData.sheetData.findIndex(
        (sheetDataPoint) => sheetDataPoint.Date === startDate,
      ),
      findLastIndex(electionsData.sheetData, (item) => item.Date === endDate) +
        1,
    );
  }

  function getDistinctWinners(sheetDataPoints: SheetDataPoint[]): Winner[] {
    const distinctWinners: Winner[] = [];

    sheetDataPoints.forEach((sheetDataPoint) => {
      if (
        !distinctWinners.find(
          (distinctWinner) => distinctWinner.winner === sheetDataPoint.winner,
        )
      ) {
        distinctWinners.push({
          winner: sheetDataPoint.winner,
          URL: sheetDataPoint.URL,
        });
      }
    });

    distinctWinners.forEach((winner, index) => {
      distinctWinners[index].winnerColor =
        WINNER_COLORS[index] || getRandomColor();
    });

    return distinctWinners;
  }

  return (
    <div className="us-elections-widget__graph-section">
      <p>Current graph for selected period of time</p>
      <GraphOptions
        winners={scopedDistinctWinners}
        selectedWinners={selectedWinners}
        setSelectedWinners={setSelectedWinners}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <Graph sheetData={scopedElectionsData} winners={selectedWinners} />
    </div>
  );
}

export default GraphSection;
